import { TDispatch } from '../type';
import { TFoco } from './foco.type';

export const focoReducer = (state: TFoco, { type, payload }: TDispatch): TFoco => {
  switch (type) {
    case 'set_foco':
      return { ...(payload as TFoco) };
    default:
      return state;
  }
};

focoReducer.key = 'foco';
focoReducer.initialState = { isFoco: null, isFocoNotPremium: null, isPremium: null };

export default { focoReducer };
